import MultipleDevicesContent from "./MultipleDevicesContent";

export default MultipleDevicesContent;